/**
 * Route for `igaming-tiered-commission-by-ngr-ftd-wager-thresholds`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { IgamingTieredCommissionByNgrFtdWagerThresholdsPage } from "../features/igaming-tiered-commission-by-ngr-ftd-wager-thresholds/IgamingTieredCommissionByNgrFtdWagerThresholdsPage";

export const igamingTieredCommissionByNgrFtdWagerThresholdsRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/igaming-tiered-commission-by-ngr-ftd-wager-thresholds",
	component: IgamingTieredCommissionByNgrFtdWagerThresholdsPage,
});

export default igamingTieredCommissionByNgrFtdWagerThresholdsRoute;
